export default defineNuxtRouteMiddleware(async (to) => {
	const auth = useAuthStore();

	// console.log('Incoming query params:', to.query);
	// console.log('To Query Token:', to?.query?.token);

	if (to.query.token) {
		const token = to.query.token as string;
		// console.log('Token found:', to.query.token);

		// Save the token in the store
		auth.token = token;

		try {
			// Fetch the authenticated user using the token
			const response = await $fetch('/auth/login-with-token', {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});

			// Set the user in the store
			auth.user = response.user;
			await auth.fetchProfile();

			// Remove the token from the query string for a cleaner URL
			return navigateTo(to.path, { replace: true });
		} catch (error) {
			// console.error('Token validation failed:', error);

			// Clear authentication state if the token is invalid
			auth.clear();
		}
	}
});
